<template>
  <div>
    <div class=" form-wrap" v-for="order of orders">
      <div class="form-list px-2 py-2">


      <template v-if="!isMobileBreakpoint">
      <div class="row">
        <div class="col-lg-6">

          <!-- 注文番号 -->
          <div class="row order-no-area">
            <div class="col">
              <div class="order-no"><trans-text i18nKey="ui['5_4'][1]" />: {{order.order_no}} </div>
            </div>
            <div class="col-auto order-status-wrap">
              <div class="order-status">
                <trans-text i18nKey="ui[91][2]"/>
              </div>
            </div>

          </div>

          <!-- 注文者情報 -->

          <div class="row mt-2">
            <div class="col-12">
              <div class="orderer-head"><trans-text i18nKey="ui['5_4'][2]" /></div>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][3]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1">{{order.buyer_user.family_name}} {{order.buyer_user.given_name}}</p>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][4]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][5]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <div class="form-group row mb-0">
            <div class="offset-5 col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <div class="form-group row mb-0">
            <div class="offset-5 col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <div class="form-group row mb-0">
            <div class="offset-5 col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <!-- 詳細情報 -->

          <div class="row mt-2">
            <div class="col-12">
              <div class="orderer-head"><trans-text i18nKey="ui['5_4'][6]" /></div>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][7]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1">{{order.created_date_disp}}</p>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][8]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <!-- 項目 オプション販売 未実装 -->
          <!--<div class="form-group row mb-0">-->
            <!--<label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][9]"/></label>-->
            <!--<div class="col-7">-->
              <!--<p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>-->
            <!--</div>-->
          <!--</div>-->

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][10]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][3]"/></p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">

          <!-- 商品ダウンロードボタン -->
          <!--<div class="text-right mb-5" v-if="order.is_demo && order.is_demo_want_data">-->
            <!--<router-link tag="button" class="btn-download btn btn-lg btn-warning w-75 py-2"　:to="{ name: 'mypage::order::download', params: {order_id:order.id} }" >-->
              <!--<trans-text i18nKey="ui['5_4'][16]" />-->
            <!--</router-link>-->
          <!--</div>-->

          <!-- イベント情報リスト -->
          <template v-for="orderEvent of order.order_events">
          <div class="row mt-2">
            <div class="col-12">
              <div class="orderer-head"><trans-text i18nKey="ui['5_4'][12]" /></div>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][13]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1">{{orderEvent.event.name}}</p>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][14]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
            </div>
          </div>

          <!-- 項目-->
          <div class="form-group row mb-0">
            <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][15]"/></label>
            <div class="col-7">
              <p class="form-control-static py-1">{{orderEvent.event.organization.name}}</p>
            </div>
          </div>
          </template>

        </div>
      </div>
      </template>
      <template v-else>
        <div class="row" style="">
          <div class="col-12">
            <div class="row order-no-area mx-1-gutters">
              <div class="col">
                <div class="order-no"><trans-text i18nKey="ui['5_4'][1]" />: {{order.order_no}}</div>
              </div>
              <div class="col-auto order-status-wrap">
                <div class="order-status">
                  <trans-text i18nKey="ui[91][2]"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <!-- 商品ダウンロードボタン -->
                <div class="text-right my-2" v-if="order.is_demo && order.is_demo_want_data">
                  <router-link tag="button" class="btn-download btn btn-warning py-2 px-3" style="font-size:.8rem; width: 60%;" 　:to="{ name: 'mypage::order::download', params: {order_id:order.id} }" >
                    <trans-text i18nKey="ui['5_4'][16]" />
                  </router-link>
                </div>
              </div>
            </div>

            <!-- イベント情報リスト -->
            <template v-for="orderEvent of order.order_events">
              <div class="row mt-2">
                <div class="col-12">
                  <div class="orderer-head"><trans-text i18nKey="ui['5_4'][12]" /></div>
                </div>
              </div>

              <!-- 項目-->
              <div class="form-group row mb-0">
                <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][13]"/></label>
                <div class="col-7">
                  <p class="form-control-static py-1">{{orderEvent.event.name}}</p>
                </div>
              </div>

              <!-- 項目-->
              <div class="form-group row mb-0">
                <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][14]"/></label>
                <div class="col-7">
                  <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
                </div>
              </div>

              <!-- 項目-->
              <div class="form-group row mb-0">
                <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][15]"/></label>
                <div class="col-7">
                  <p class="form-control-static py-1">{{orderEvent.event.organization.name}}</p>
                </div>
              </div>
            </template>

            <template v-if="order.isShowDetail">
            <!-- 注文者情報 -->

            <div class="row mt-2">
              <div class="col-12">
                <div class="orderer-head"><trans-text i18nKey="ui['5_4'][2]" /></div>
              </div>
            </div>

            <!-- 項目-->
            <div class="form-group row mb-0">
              <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][3]"/></label>
              <div class="col-7">
                <p class="form-control-static py-1">{{order.buyer_user.family_name}} {{order.buyer_user.given_name}}</p>
              </div>
            </div>

            <!-- 項目-->
            <div class="form-group row mb-0">
              <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][4]"/></label>
              <div class="col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
              </div>
            </div>

            <!-- 項目-->
            <div class="form-group row mb-0">
              <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][5]"/></label>
              <div class="col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="offset-5 col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="offset-5 col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="offset-5 col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
              </div>
            </div>

            <!-- 詳細情報 -->

            <div class="row mt-2">
              <div class="col-12">
                <div class="orderer-head"><trans-text i18nKey="ui['5_4'][6]" /></div>
              </div>
            </div>

            <!-- 項目-->
            <div class="form-group row mb-0">
              <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][7]"/></label>
              <div class="col-7">
                <p class="form-control-static py-1">{{order.created_date_disp}}</p>
              </div>
            </div>

            <!-- 項目-->
            <div class="form-group row mb-0">
              <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][8]"/></label>
              <div class="col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>
              </div>
            </div>

            <!-- 項目 オプション販売 未実装 -->
            <!--<div class="form-group row mb-0">-->
            <!--<label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][9]"/></label>-->
            <!--<div class="col-7">-->
            <!--<p class="form-control-static py-1"><trans-text i18nKey="ui[91][2]"/></p>-->
            <!--</div>-->
            <!--</div>-->

            <!-- 項目-->
            <div class="form-group row mb-0">
              <label class="col-5 col-form-label py-1"><trans-text i18nKey="ui['5_4'][10]"/></label>
              <div class="col-7">
                <p class="form-control-static py-1"><trans-text i18nKey="ui[91][3]"/></p>
              </div>
            </div>
            </template>

            <!-- フォーム送信UI -->
            <div class="row text-center">
              <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
                <div class="my-4">
                  <button type="button" class="btn-show-detail btn w-75 btn-warning py-1 px-1" :class="{expand:order.isShowDetail,colapse:!order.isShowDetail}" @click="toggleShowDetail(order)" ><trans-text i18nKey="ui['5_4'][6]"/></button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </template>
    </div>
  </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  /** @see page_subPages_MyPage_Order_History parent component */
  export default {
    extends:FormPartialBase,
    props:["orders"],
    components: {

    },
    data () {
      return {
//        input: {
//          family_name: "",
//          given_name: "",
//          address_1:"",
//          address_2:"",
//          city:"",
//          prefecture:"",
//          zip_code:"",
//          phone_nunber:"",
//          country_name:"",
//          email: "",
//
//
//          password: "",
//          confirm_password: "",
//        }
      }
    },
//    validations: {
//      input: {
//        family_name: {
//          required
//        },
//        given_name: {
//          required
//        },
//        email: {
//          required,
//          email,
//        },
//        password: {
//          required,
//          alphaNum,
//          minLength: minLength(8),
//        },
//        confirm_password: {
//          required,
//          sameAsPassword: sameAs('password'),
//        },
//      },
//    },
    created(){
    },
    computed:{
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },
    },
    methods:{
      toggleShowDetail(order){
          dd("test",order.id)
        this.$emit("toggleShowDetail",order)
      }
//      tryForm(e){
//        //バリデーション
//        if(this.$v.input.$invalid){
//          this.$v.input.$touch()
//          return
//        }
//        this.$emit('tryForm', this.input)
//      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/_variables";

  .order-no-area {
    .order-no {
      background-color: #82ba1d;
      color: #fff;
      font-size: 0.7rem;
      font-weight: bold;
      padding: .1rem .5rem;
    }
    .order-status-wrap{
      @media(min-width: map-get($grid-breakpoints, "sm")) {
        padding-right:15px;
      }
      .order-status{
        color: #fff;
        background-color: #586167;
        font-size: 0.9rem;
        font-weight: bold;
        padding: .1rem .5rem;
      }
    }
  }
  .orderer-head{
    border: 1px solid #82ba1d;
    color: #82ba1d;
    font-size: 0.9rem;
    font-weight: bold;
    padding: .1rem .5rem;
  }

  .btn-download{
    position: relative;
    &:before{
      font-family: FontAwesome;
      content: '\f019';
      font-size:1.2rem;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(0);
      left: 5%;
    }
  }

  .btn-show-detail{
    position: relative;
    &.expand:before{
      font-family: FontAwesome;
      content: '\f0d8';
      font-size:1.2rem;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(0);
      right: 5%;
    }
    &.colapse:before{
      font-family: FontAwesome;
      content: '\f0d7';
      font-size:1.2rem;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(0);
      right: 5%;
    }
  }

  /*.order-history-area {*/



  /*}*/
  /*.orderer-header{*/
    /*color:#82ba1d;*/
    /*border:1px solid #82ba1d;*/
  /*}*/

  /*.form-list{*/
    /*padding:1rem;*/
  /*}*/


</style>



// WEBPACK FOOTER //
// PageContent.vue?004e77d6